import { TwainGameId } from 'betgames-contract-js';

export const BIG_POINTS_AMOUNT: Partial<Record<TwainGameId, number>> = {
    [TwainGameId.B_RING]: 60,
    [TwainGameId.T_KICK]: 30,
    [TwainGameId.RNG_T_KICK]: 30,
};

export const SMALL_SHOTS_AMOUNT: Partial<Record<TwainGameId, number>> = {
    [TwainGameId.B_RING]: 4,
    [TwainGameId.T_KICK]: 7,
};
